import { Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'luxon';

@Pipe({
    name: 'formatDate',
    standalone: false
})
export class FormatDatePipe implements PipeTransform {
  transform(text: string | DateTime, format: string = 'dd/MM/yy'): string {
    if (!text) {
      return null;
    }

    return typeof text === 'string' ? DateTime.fromISO(text).toFormat(format) : text.toFormat(format);
  }
}
